/* This file is autogenerated, see readme.md for instructions */
import CalendarSvgIcon from '@bloomreach/banana-theme/icons/calendar.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CalendarIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CalendarSvgIcon />
    </Icon>
  );
});

CalendarIcon.displayName = 'CalendarIcon';

export default CalendarIcon;
